// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-6VJ5","quit":"Card_quit__uLEkd","details":"Card_details__6FASi","like":"Card_like__lHBPz"};